export default __webpack_public_path__ + "53a9733ad5c8001f1cd20b1eab819a4a.webp";